import * as types from '../mutation-types'
import axios from "axios";

// state
export const state = {
    selected: [],
};

// getters
export const getters = {
    selected: state => state.selected,
};

// mutations
export const mutations = {
    [types.OPERATIONS_SELECTED_PUSH] (state, data) {
        if (typeof data === 'object' && Array.isArray(data)) {
            state.selected.push(...data);
        } else {
            state.selected.push(data);
        }
        state.selected = _.uniq(state.selected);
    },
    [types.OPERATIONS_SELECTED_PULL] (state, data) {
        if (typeof data === 'object' && Array.isArray(data)) {
            state.selected = _.without(_.clone(state.selected), ...data);
        } else {
            state.selected = _.without(_.clone(state.selected), data);
        }
    }
};

// actions
export const actions = {
    selectedPush(context, data) {
        context.commit(types.OPERATIONS_SELECTED_PUSH, data);
    },
    selectedPull(context, data) {
        context.commit(types.OPERATIONS_SELECTED_PULL, data);
    }
};
